import { render, staticRenderFns } from "./jfpz.vue?vue&type=template&id=28f6b912&"
import script from "./jfpz.vue?vue&type=script&lang=js&"
export * from "./jfpz.vue?vue&type=script&lang=js&"
import style0 from "./jfpz.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports